import {
  bumpPickItem,
  completeHandover,
  completePickList,
  flagOrderDelay,
  markItemUnavailable,
  markOrderReady,
  overrideFulfilmentGate,
  pickItem,
  proposeSubstitution,
  recallTicket,
  recordAgeCheck,
  recordPickWeight,
  refuseHandover,
  startPreparation,
  verifyCollection,
} from '../kitchen-display/kitchenDisplayApi.js';
import { setReplayingFloorQueue } from '../kitchen-display/floorAwareWrite.js';
import {
  type FloorWriteItem,
  loadFloorWriteQueue,
  saveFloorWriteQueue,
  updateFloorWriteItem,
} from './floorWriteQueue.js';

async function replayItem(item: FloorWriteItem): Promise<void> {
  const { kind, orderId, itemId, payload } = item;
  if (!orderId && kind !== 'start_prep') {
    throw new Error('Missing order id');
  }
  switch (kind) {
    case 'start_prep':
      await startPreparation(orderId!, payload);
      break;
    case 'flag_delay':
      await flagOrderDelay(orderId!, payload);
      break;
    case 'bump_item':
      await bumpPickItem(orderId!, itemId!, payload);
      break;
    case 'recall_ticket':
      await recallTicket(orderId!, payload);
      break;
    case 'pick_item':
      await pickItem(orderId!, itemId!, payload);
      break;
    case 'mark_unavailable':
      await markItemUnavailable(orderId!, itemId!, payload);
      break;
    case 'record_weight':
      await recordPickWeight(orderId!, itemId!, payload);
      break;
    case 'propose_substitution':
      await proposeSubstitution(orderId!, payload);
      break;
    case 'complete_pick':
      await completePickList(orderId!, payload);
      break;
    case 'verify_collection':
      await verifyCollection(orderId!, String(payload.handoverCode ?? ''));
      break;
    case 'complete_handover':
      await completeHandover(orderId!, payload);
      break;
    case 'refuse_handover':
      await refuseHandover(orderId!, payload);
      break;
    case 'record_age_check':
      await recordAgeCheck(orderId!, payload);
      break;
    case 'mark_ready':
      await markOrderReady(orderId!, payload);
      break;
    case 'override_gate':
      await overrideFulfilmentGate(orderId!, payload);
      break;
    default:
      throw new Error(`Unknown floor write kind: ${kind}`);
  }
}

export async function drainFloorWriteQueue(): Promise<{ synced: number; failed: number }> {
  const pending = loadFloorWriteQueue().filter((q) => q.status === 'pending');
  let synced = 0;
  let failed = 0;
  setReplayingFloorQueue(true);
  try {
    for (const item of [...pending].reverse()) {
      try {
        await replayItem(item);
        updateFloorWriteItem(item.id, { status: 'synced' });
        synced++;
      } catch {
        updateFloorWriteItem(item.id, {
          status: 'failed',
          retryCount: item.retryCount + 1,
        });
        failed++;
      }
    }
  } finally {
    setReplayingFloorQueue(false);
  }
  saveFloorWriteQueue(loadFloorWriteQueue().filter((q) => q.status !== 'synced'));
  return { synced, failed };
}
